export default __webpack_public_path__ + "static/fastCompany-596fde1dfef65ede561b8aa393852553.svg";